import React from 'react';
import { useEffect } from 'react';
import { Helmet } from "react-helmet";

import ServicesSubMenu from './ServicesSubMenu';
import Technologies from '../components/Technologies';
import { Link } from "react-router-dom";
import { techDescription, SITE_URL } from './../constants'

function ServiceContent(props) {

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  const {
    pageTitle,
    title,
    description,
    // img, // Currently unused - kept for future image display feature
    useCases,
    bestPractices,
    breadCrumpMenu,
    currentMenuPage,
    faqs
  } = props;

  // Generate keywords from page title and description
  const generateKeywords = () => {
    const baseKeywords = "CaptainMe.AI, AI consulting, machine learning, AWS";
    const pageKeywords = pageTitle.toLowerCase().replace(/[&]/g, '').split(' ').slice(0, 5).join(', ');
    return `${baseKeywords}, ${pageKeywords}`;
  };

  // Truncate description for Twitter
  const truncateDescription = (desc) => {
    return desc.length > 200 ? desc.substring(0, 197) + '...' : desc;
  };

  const canonicalUrl = `${SITE_URL}${currentMenuPage}`;

  return (
    <React.Fragment>
      <Helmet>
        <title>{pageTitle} | CaptainMe.AI</title>
        <meta name="description" content={description}></meta>
        <meta name="keywords" content={generateKeywords()}></meta>
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={`${pageTitle} | CaptainMe.AI`}></meta>
        <meta property="og:description" content={description}></meta>
        <meta property="og:type" content="website"></meta>
        <meta property="og:url" content={canonicalUrl}></meta>
        <meta property="og:image" content={`${SITE_URL}/ogg-captain-me-ai.jpg`}></meta>
        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta name="twitter:title" content={`${pageTitle} | CaptainMe.AI`}></meta>
        <meta name="twitter:description" content={truncateDescription(description)}></meta>
        <meta name="twitter:image" content={`${SITE_URL}/ogg-captain-me-ai.jpg`}></meta>
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          "name": pageTitle,
          "description": description,
          "provider": {
            "@type": "Organization",
            "name": "CaptainMe AI",
            "url": SITE_URL
          },
          "areaServed": "Worldwide",
          "serviceType": "AI & Machine Learning Consulting",
          "url": canonicalUrl
        })}</script>
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {"@type": "ListItem", "position": 1, "name": "Home", "item": `${SITE_URL}/`},
            {"@type": "ListItem", "position": 2, "name": "Services"},
            {"@type": "ListItem", "position": 3, "name": breadCrumpMenu, "item": canonicalUrl}
          ]
        })}</script>
        {faqs && faqs.length > 0 && (
          <script type="application/ld+json">{JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqs.map(faq => ({
              "@type": "Question",
              "name": faq.question,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": faq.answer
              }
            }))
          })}</script>
        )}
      </Helmet>

      {/**
			=============================================
				Theme Inner Banner / Header
			============================================== 
      */}
      <div className="theme-inner-banner">
        <div className="container">
          <h2 className="intro-title text-center">{pageTitle}</h2>
          <ul className="page-breadcrumb style-none d-flex justify-content-center">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>Services</li>
            <li className="current-page">{breadCrumpMenu}</li>
          </ul>
        </div>
      </div>

      {/* <!-- 
			=============================================
				Service Details
			============================================== 
			--> */}
      <div className="service-details position-relative mt-30 mb-40">
        <div className="container">
          <div className="row">
            <div className="col-xl-8 col-lg-8 order-lg-1">
              <div className="service-details-meta ms-xxl-4">
                <h2 className="sub-title">{title}</h2>
                <p>{description}</p>

                {/* <img src={img || image_13} alt="" className="main-img-meta" /> */}

                <div className="mt-75 lg-mt-50">
                  <div className="row gx-xxl-5">

                    {/* <!-- 
                        =============================================
                          Use Cases
                        ============================================== 
                    --> */}
                    <div className="col-lg-6">
                      <h3 className="sub-title">Use Cases</h3>
                      <ul className="style-none list-item md-mb-40">
                        {useCases.map((val, index) => {
                          const key = `use-cases-item-${index}`
                          return (
                            <li key={key}>{val}</li>
                          )
                        })}
                      </ul>
                    </div>
                    {/* <!-- 
                        =============================================
                          Best Practices
                        ============================================== 
                    --> */}
                    <div className="col-lg-6">
                      <h3 className="sub-title">Best Practices</h3>
                      <ul className="style-none list-item md-mb-40">
                        {bestPractices.map((val, index) => {
                          const key = `best-practices-item-${index}`
                          return (
                            <li key={key}>{val}</li>
                          )
                        })}
                      </ul>
                    </div>
                  </div>
                </div>

                <h3 className="sub-title mt-20" >Technology we use</h3>
                <p>{techDescription}</p>
                <Technologies />
              </div>
            </div>
            <ServicesSubMenu currentPage={currentMenuPage} />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
export default ServiceContent;
